/**
 * @generated SignedSource<<9a860741a147d3a61a40fcb32cea376e>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}
export type GlobalOperationsUserPermissionTypeQuery_user_AtlassianUser_confluence_ConfluenceUser =
  {
    __typename?: "ConfluenceUser";
    permissionType: SitePermissionType | null;
  };
export type GlobalOperationsUserPermissionTypeQuery_user_AtlassianUser = {
  __typename?: "AtlassianUser";
  id: string | null;
  confluence: GlobalOperationsUserPermissionTypeQuery_user_AtlassianUser_confluence_ConfluenceUser | null;
};
export type GlobalOperationsUserPermissionTypeQuery_Query = {
  __typename?: "Query";
  user: GlobalOperationsUserPermissionTypeQuery_user_AtlassianUser | null;
};
export type GlobalOperationsUserPermissionTypeQueryVariables = Exact<{
  [key: string]: never;
}>;
export type GlobalOperationsUserPermissionTypeQuery =
  GlobalOperationsUserPermissionTypeQuery_Query;
